import { atom } from 'jotai';

const pdpEditOrderErrorMessageAtom = atom(null);

export default pdpEditOrderErrorMessageAtom;
